import React from "react";

const TabPanel = ({ children, value, index, ...rest }) => {
  return value === index && <div {...rest}>{children}</div>;
};

export default TabPanel;
